// M2V.io - API Client
import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor - add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('m2v_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('m2v_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// Gallery API
export const galleryApi = {
  getPublic: (params?: { page?: number; page_size?: number; language?: string }) =>
    api.get('/gallery/public', { params }),
    
  getMine: (params?: { page?: number; page_size?: number }) =>
    api.get('/gallery/mine', { params })
}

// Payments API
export const paymentsApi = {
  getPrices: () => api.get('/payments/prices'),
  
  createCheckout: (creditsAmount: number, successUrl?: string, cancelUrl?: string) =>
    api.post('/payments/checkout-session', {
      credits_amount: creditsAmount,
      success_url: successUrl,
      cancel_url: cancelUrl
    })
}

export default api
